export const supplierStatusIds = {
  prospect: 1,
  active: 2,
  destocking: 3,
  inactive: 4,
} as const;

export const activeSupplierStatusIds = [
  supplierStatusIds.prospect,
  supplierStatusIds.active,
];
